const EmailShare = ({ width, height, color, ...props }) => (
  <svg
    width={width || '22'}
    height={height || '18'}
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.875 0.75H3.125C2.42904 0.750744 1.76179 1.02755 1.26967 1.51967C0.777545 2.01179 0.500744 2.67904 0.5 3.375V14.625C0.500744 15.321 0.777545 15.9882 1.26967 16.4803C1.76179 16.9725 2.42904 17.2493 3.125 17.25H18.875C19.571 17.2493 20.2382 16.9725 20.7303 16.4803C21.2225 15.9882 21.4993 15.321 21.5 14.625V3.375C21.4993 2.67904 21.2225 2.01179 20.7303 1.51967C20.2382 1.02755 19.571 0.750744 18.875 0.75ZM18.2103 5.09203L11.4603 10.342C11.3287 10.4444 11.1667 10.4999 11 10.4999C10.8333 10.4999 10.6713 10.4444 10.5397 10.342L3.78969 5.09203C3.71038 5.03214 3.64377 4.95709 3.59372 4.87123C3.54367 4.78537 3.51118 4.69042 3.49815 4.5919C3.48511 4.49338 3.49179 4.39325 3.51778 4.29733C3.54378 4.20142 3.58858 4.11162 3.64958 4.03316C3.71058 3.95471 3.78656 3.88916 3.87312 3.84032C3.95967 3.79149 4.05506 3.76034 4.15376 3.74869C4.25245 3.73704 4.35248 3.74513 4.44802 3.77247C4.54357 3.79981 4.63272 3.84587 4.71031 3.90797L11 8.79984L17.2897 3.90797C17.447 3.7892 17.6447 3.73711 17.84 3.76296C18.0354 3.78881 18.2128 3.89053 18.3338 4.04612C18.4547 4.20171 18.5096 4.39866 18.4865 4.59439C18.4634 4.79011 18.3642 4.96888 18.2103 5.09203Z"
      fill={color || '#120232'}
    />
  </svg>
);

export default EmailShare;
